<main class="oman-page">
    <header class="oman-heading">
        <div class="container">
            <h1>Oman</h1>
        </div>
    </header>

    <div class="oman-tabs">
        <div class="container">
            <div class="oman-tablist" role="tablist" aria-label="Explore Oman"
                [attr.data-active]="activeTab">
                <button type="button" class="oman-tab" role="tab"
                    id="oman-tab-fixer" aria-controls="oman-panel-fixer"
                    [attr.aria-selected]="activeTab === 'fixer'"
                    [attr.tabindex]="activeTab === 'fixer' ? 0 : -1"
                    (click)="selectTab('fixer')" (keydown)="onTabKeydown($event)">
                    <i class="bx bx-map-alt" aria-hidden="true"></i>
                    <span>Oman Fixer</span>
                </button>
                <button type="button" class="oman-tab" role="tab"
                    id="oman-tab-filming" aria-controls="oman-panel-filming"
                    [attr.aria-selected]="activeTab === 'filming'"
                    [attr.tabindex]="activeTab === 'filming' ? 0 : -1"
                    (click)="selectTab('filming')" (keydown)="onTabKeydown($event)">
                    <i class="bx bx-camera-movie" aria-hidden="true"></i>
                    <span>Filming in Oman</span>
                </button>
                <button type="button" class="oman-tab" role="tab"
                    id="oman-tab-about" aria-controls="oman-panel-about"
                    [attr.aria-selected]="activeTab === 'about'"
                    [attr.tabindex]="activeTab === 'about' ? 0 : -1"
                    (click)="selectTab('about')" (keydown)="onTabKeydown($event)">
                    <i class="bx bx-world" aria-hidden="true"></i>
                    <span>About Oman</span>
                </button>
            </div>
        </div>
    </div>

    <div class="oman-tab-panel" id="oman-panel-fixer" role="tabpanel"
        aria-labelledby="oman-tab-fixer" tabindex="0"
        *ngIf="openedTabs.fixer" [hidden]="activeTab !== 'fixer'">
        <app-oman-fixer></app-oman-fixer>
    </div>

    <div class="oman-tab-panel" id="oman-panel-filming" role="tabpanel"
        aria-labelledby="oman-tab-filming" tabindex="0"
        *ngIf="openedTabs.filming" [hidden]="activeTab !== 'filming'">
        <app-filming-in-oman></app-filming-in-oman>
    </div>

    <div class="oman-tab-panel" id="oman-panel-about" role="tabpanel"
        aria-labelledby="oman-tab-about" tabindex="0"
        *ngIf="openedTabs.about" [hidden]="activeTab !== 'about'">
        <app-about-oman></app-about-oman>
    </div>
</main>
